module.exports = __webpack_public_path__ + "static/media/email.d167440d.svg";